import { render } from "./InputNotify.vue?vue&type=template&id=1bf38e59"
import script from "./InputNotify.vue?vue&type=script&lang=js"
export * from "./InputNotify.vue?vue&type=script&lang=js"

import "./InputNotify.vue?vue&type=style&index=0&id=1bf38e59&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__